import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "notifications-box:NotificationList"
}
const _hoisted_2 = {
  key: 0,
  class: "_pa-2"
}
const _hoisted_3 = { class: "_tc--lighter _ttu" }
const _hoisted_4 = {
  key: 1,
  class: "_bgc--light _pa-2"
}
const _hoisted_5 = { class: "_tc--lighter _ttu" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_push_notification_list_item = _resolveComponent("push-notification-list-item")
  const _component_push_notification_list_empty_state = _resolveComponent("push-notification-list-empty-state")

  return ($options.hasNotificationToDisplay)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.hasUnseenNotification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Resources.Layout.UnseenLabel), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.unseenNotification, (notification) => {
                return (_openBlock(), _createBlock(_component_push_notification_list_item, _mergeProps({
                  key: notification.pushNotificationID
                }, { ref_for: true }, notification, {
                  class: "_mt-1",
                  "data-qa": `unseen-notification:${notification.userNotificationID}`
                }), null, 16 /* FULL_PROPS */, ["data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        ($options.hasSeenNotification)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.Layout.SeenLabel), 1 /* TEXT */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.seenNotification, (notification) => {
                return (_openBlock(), _createBlock(_component_push_notification_list_item, _mergeProps({
                  key: notification.pushNotificationID
                }, { ref_for: true }, notification, {
                  class: "_mt-1",
                  "data-qa": `already-seen-notification:${notification.userNotificationID}`
                }), null, 16 /* FULL_PROPS */, ["data-qa"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createBlock(_component_push_notification_list_empty_state, {
        key: 1,
        class: "_px-2"
      }))
}